module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ann Leary\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Ann Lembeck Leary has written for television and film. She is married to actor Denis Leary. They have two children, including a now healthy and hearty teenaged Jack, and live on a farm in Connecticut.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jIHicE/tc-custom/9780062032379.jpg?1731883366368",
      "alt": "This image is the cover for the book Innocent, a Broad"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Innocent, a Broad\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When Ann Leary and her husband, then unknown actor-comedian Denis Leary, flew to London in the early nineties for a brief getaway during Ann's second trimester of pregnancy, neither anticipated the adventure that was in store for them. The morning after their arrival, Ann's water broke as they strolled through London's streets. A week later their son, Jack, was born weighing only two pounds, six ounces, and it would be five long months before mother and son could return to the States.")]), _c('p', [_vm._v("In the meantime, Ann became an unwitting yet grateful hostage to Britain's National Health Service -- a stranger in a strange land plunged abruptly into a world of breast pumps and midwives, blood oxygen levels, mad cow disease, and poll tax riots. Desperately worried about the health of her baby, Ann struggled to adapt to motherhood and make sense of a very different culture. At once an intimate family memoir, a lively travelogue, and a touching love story, "), _c('b', [_vm._v("An Innocent, a Broad")]), _vm._v(" is utterly engaging and unforgettable.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins Publishers\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0